




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class FileOpenAlertModal extends Vue {
    title = "読み込めませんでした";
    message = "選択したファイルの形式は読み込めません。他の形式のファイルを選択してください。";

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
